<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import SiteBase from '../../../../sites/components/SiteBase.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        navItem: {
            label: 'Settings',
            icon: 'pi pi-user',
            route: '/(app)/settings/business/',
        },
        navConfig: {
            order: 40,
            navHeader: true,
            leftDrawer: true,
        },
        childNavItems: [
            {
                label: 'Business',
                route: '/(app)/settings/business/',
            },
            {
                label: 'Buildings',
                route: '/(app)/settings/buildings/',
            },
            {
                label: 'Skills',
                route: '/(app)/settings/skills/',
            },
            {
                label: 'Groups',
                route: '/(app)/settings/groups/',
            },
            {
                label: 'Shift Reasons',
                route: '/(app)/settings/shift-reasons/',
            },
        ],
    }
})
</script>

<template>
  <SiteBase />
</template>